import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getAmitasoftSiteUrls } from "../utils/amitasoftSiteUrls";
import { AMITASOFT_BRAND } from "../theme/amitasoftBrand";
import { AMITASOFT_TYPO } from "../theme/amitasoftTypography";

export default function BlogNotFound() {
  const siteUrls = getAmitasoftSiteUrls();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
      <Typography
        component="p"
        sx={{
          fontFamily: AMITASOFT_TYPO.fontFamily,
          ...AMITASOFT_TYPO.bodySm,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: AMITASOFT_BRAND.textMuted,
          mb: 2,
        }}
      >
        404 — Page not found
      </Typography>
      <Typography
        component="h1"
        sx={{
          fontFamily: AMITASOFT_TYPO.fontFamily,
          ...AMITASOFT_TYPO.section,
          color: AMITASOFT_BRAND.deepPurple,
          mb: 2,
        }}
      >
        This blog page doesn&apos;t exist
      </Typography>
      <Typography
        sx={{
          fontFamily: AMITASOFT_TYPO.fontFamily,
          ...AMITASOFT_TYPO.body,
          color: AMITASOFT_BRAND.textMuted,
          maxWidth: "36rem",
          mx: "auto",
          mb: 4,
        }}
      >
        The article or URL may have moved. Head back to the blog listing or visit the  marketing site.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "center" }}>
        <Button
          component={Link}
          to="/blog/"
          variant="contained"
          sx={{
            bgcolor: AMITASOFT_BRAND.cliqTeal,
            fontFamily: AMITASOFT_TYPO.fontFamily,
            fontWeight: 700,
            ...AMITASOFT_TYPO.buttonSm,
            textTransform: "uppercase",
            "&:hover": { bgcolor: AMITASOFT_BRAND.cliqTealHover },
          }}
        >
          Back to blogs
        </Button>
        <Button
          component="a"
          href={siteUrls.marketingHome}
          variant="outlined"
          sx={{
            borderColor: AMITASOFT_BRAND.deepPurple,
            color: AMITASOFT_BRAND.deepPurple,
            fontFamily: AMITASOFT_TYPO.fontFamily,
            fontWeight: 600,
            "&:hover": { borderColor: AMITASOFT_BRAND.deepPurple, bgcolor: "rgba(55,57,115,0.06)" },
          }}
        >
           home
        </Button>
      </Box>
    </Container>
  );
}
